var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInProgressRepaymentsActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.06 18.2699C25.06 18.2699 25.0546 18.2699 25.0505 18.2699C24.9497 18.2671 24.8598 18.2086 24.8148 18.1187L22.2147 12.8489C22.1724 12.7644 22.1779 12.665 22.2283 12.5846C22.2773 12.5043 22.3659 12.4566 22.4598 12.4566H23.9377C24.0875 12.4566 24.2101 12.5792 24.2101 12.729C24.2101 12.8788 24.0875 13.0014 23.9377 13.0014H22.8984L25.0791 17.4213L27.6302 13.0014H26.482C26.3322 13.0014 26.2096 12.8788 26.2096 12.729C26.2096 6.41312 21.0705 1.27407 14.7533 1.27407C11.6928 1.27407 8.81608 2.46587 6.65313 4.62883C6.54689 4.73507 6.37391 4.73507 6.26767 4.62883C6.16143 4.52258 6.16143 4.3496 6.26767 4.24336C8.53414 1.9769 11.547 0.729248 14.7533 0.729248C21.2803 0.729248 26.6059 5.96501 26.7517 12.4566H28.1028C28.1996 12.4566 28.2908 12.5083 28.3385 12.5928C28.3875 12.6772 28.3875 12.7808 28.3385 12.8652L25.2956 18.135C25.2466 18.2195 25.1567 18.2712 25.06 18.2712V18.2699Z",
    fill: "url(#paint0_linear_261_3497)",
    stroke: "url(#paint1_linear_261_3497)",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7547 24.7289C8.2291 24.7289 2.90345 19.4931 2.75771 13.0002H1.40655C1.30984 13.0002 1.21858 12.9484 1.17091 12.864C1.12324 12.7795 1.12188 12.676 1.17091 12.5916L4.21375 7.32175C4.26279 7.23731 4.35268 7.18555 4.44939 7.18555C4.54609 7.18555 4.63735 7.23731 4.68502 7.32175L7.72787 12.5916C7.7769 12.676 7.7769 12.7795 7.72787 12.864C7.67883 12.9484 7.58894 13.0002 7.49223 13.0002H5.57445C5.42462 13.0002 5.30204 12.8776 5.30204 12.7278C5.30204 12.5779 5.42462 12.4554 5.57445 12.4554H7.02096L4.45075 8.00278L1.87782 12.4567H3.02604C3.17586 12.4567 3.29845 12.5793 3.29845 12.7291C3.29845 19.0464 8.4375 24.1854 14.7534 24.1854C17.8139 24.1854 20.6906 22.9936 22.8535 20.8293C22.9598 20.7231 23.1328 20.7231 23.239 20.8293C23.3452 20.9355 23.3452 21.1085 23.239 21.2148C20.9739 23.4812 17.9597 24.7302 14.7534 24.7302L14.7547 24.7289Z",
    fill: "url(#paint2_linear_261_3497)",
    stroke: "url(#paint3_linear_261_3497)",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5999 17.8942H10.9097C10.832 17.8942 10.7585 17.8615 10.7067 17.8029C10.655 17.7444 10.6305 17.6681 10.64 17.5905C10.753 16.6111 11.1085 15.6618 11.667 14.8459C12.0879 14.2316 12.6136 13.7031 13.2293 13.2741C13.3532 13.1883 13.5221 13.2183 13.6079 13.3422C13.6937 13.4661 13.6638 13.635 13.5398 13.7209C12.9787 14.1104 12.4992 14.5926 12.1165 15.1524C11.6656 15.8103 11.3605 16.5635 11.2243 17.348H18.2852C17.9924 15.655 16.9313 14.1853 15.4018 13.3776L13.8517 12.5577C12.0729 11.6165 10.8729 9.86214 10.6386 7.86536C10.6236 7.7346 10.704 7.61065 10.8307 7.57252C10.8606 7.56298 10.892 7.5589 10.9219 7.56162H18.5985C18.6761 7.56162 18.7511 7.59431 18.8015 7.65288C18.8532 7.71145 18.8777 7.78908 18.8682 7.86536C18.6639 9.6088 17.72 11.1806 16.2776 12.179C16.1536 12.2648 15.9847 12.2335 15.8989 12.1095C15.8131 11.9856 15.8444 11.8167 15.9684 11.7309C17.197 10.881 18.0292 9.57202 18.2839 8.10644H11.2243C11.5172 9.79948 12.5782 11.2678 14.1078 12.0768L15.6578 12.8968C17.4353 13.838 18.6366 15.5923 18.8709 17.5905C18.8832 17.6926 18.8369 17.7921 18.7511 17.8493C18.7061 17.8792 18.653 17.8956 18.5999 17.8956V17.8942Z",
    fill: "url(#paint4_linear_261_3497)",
    stroke: "url(#paint5_linear_261_3497)",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5998 19.5485H10.9096C10.7598 19.5485 10.6372 19.4259 10.6372 19.2761C10.6372 19.1262 10.7598 19.0037 10.9096 19.0037H18.5998C18.7496 19.0037 18.8722 19.1262 18.8722 19.2761C18.8722 19.4259 18.7496 19.5485 18.5998 19.5485Z",
    fill: "url(#paint6_linear_261_3497)",
    stroke: "url(#paint7_linear_261_3497)",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5998 6.45693H10.9096C10.7598 6.45693 10.6372 6.33435 10.6372 6.18452C10.6372 6.03469 10.7598 5.91211 10.9096 5.91211H18.5998C18.7496 5.91211 18.8722 6.03469 18.8722 6.18452C18.8722 6.33435 18.7496 6.45693 18.5998 6.45693Z",
    fill: "url(#paint8_linear_261_3497)",
    stroke: "url(#paint9_linear_261_3497)",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_261_3497",
    x1: 17.2816,
    y1: 0.729248,
    x2: 17.2816,
    y2: 18.2712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_261_3497",
    x1: 17.2816,
    y1: 0.729248,
    x2: 17.2816,
    y2: 18.2712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_261_3497",
    x1: 12.2267,
    y1: 7.18555,
    x2: 12.2267,
    y2: 24.7302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_261_3497",
    x1: 12.2267,
    y1: 7.18555,
    x2: 12.2267,
    y2: 24.7302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_261_3497",
    x1: 14.7549,
    y1: 7.56079,
    x2: 14.7549,
    y2: 17.8956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_261_3497",
    x1: 14.7549,
    y1: 7.56079,
    x2: 14.7549,
    y2: 17.8956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_261_3497",
    x1: 14.7547,
    y1: 19.0037,
    x2: 14.7547,
    y2: 19.5485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_261_3497",
    x1: 14.7547,
    y1: 19.0037,
    x2: 14.7547,
    y2: 19.5485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_261_3497",
    x1: 14.7547,
    y1: 5.91211,
    x2: 14.7547,
    y2: 6.45693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_261_3497",
    x1: 14.7547,
    y1: 5.91211,
    x2: 14.7547,
    y2: 6.45693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgressRepaymentsActive);
export default __webpack_public_path__ + "static/media/in-progress-repayments-active.075861b476f6c4993dbea4ce55f4a928.svg";
export { ForwardRef as ReactComponent };